import styled from "@emotion/styled";

export const Card = styled.div`
  background-color: ${({theme}) => theme.color.grayscale.white};
  border: 1px solid ${({theme}) => theme.color.grayscale[300]};
  border-radius: 4px;
  padding: 24px;
`;
